import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "el-text__primary" }, " Customer - Details ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Customer No", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Customer No ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Customer Name", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Customer Name ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Salesperson Name", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Salesperson Name ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Salesperson ID", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Salesperson ID ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Collector Name", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Collector Name ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Address Line 1", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Address Line 1 ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Address Line 2", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Address Line 2 ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "City", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" City ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "State", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" State ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Postal Code", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Postal Code ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "Phone Number", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Phone Number ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_filled = _resolveComponent("info-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_CustomerContacts = _resolveComponent("CustomerContacts")!
  const _component_CustomerNotes = _resolveComponent("CustomerNotes")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_Documents = _resolveComponent("Documents")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", null, _toDisplayString(_ctx.customer.customer_name) + " | " + _toDisplayString(_ctx.$route.params.customerNo), 1)
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_space, {
        direction: "vertical",
        style: {"display":"flex"},
        fill: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 16,
                lg: 16,
                xl: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse, {
                    modelValue: _ctx.activeCollapseItem,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeCollapseItem) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse_item, {
                        title: "Details",
                        name: "details"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_2,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_3
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.customer_no), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_4,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_5
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.customer_name), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_6,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_7
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.salesperson_name_1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_8,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_9
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.salesperson_id_1), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_10,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_11
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.collector_name), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_12,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_13
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.address_line_1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_14,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_15
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.address_line_2), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_16,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_17
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.city), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_18,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_19
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.state), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_20,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_21
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.formatted_postal_code), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, [
                                        _hoisted_22,
                                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                                          content: _withCtx(() => [
                                            _hoisted_23
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, {
                                              class: "el-text__grey",
                                              style: {"font-size":"small"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_info_filled)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.customer.formatted_phone_no), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_collapse_item, {
                        title: "Contacts",
                        name: "contacts"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomerContacts, {
                            "customer-no": _ctx.customer.customer_no
                          }, null, 8, ["customer-no"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_collapse_item, {
                        title: "Notes",
                        name: "notes"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomerNotes, {
                            "customer-no": _ctx.customer.customer_no
                          }, null, 8, ["customer-no"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Documents, {
                    "customer-no": _ctx.$route.params.customerNo.toString()
                  }, null, 8, ["customer-no"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}